import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioLoginService {

  constructor( private requestUrl: ReportesRequestService) { }

  async getUsuario(codigo: string, login: number) {
    try {
      const request = await this.requestUrl.getRequest(
        'login/info',
        [
          codigo,
          {
            'uncoLogin' : login
          }
        ]);
      return request;
    } catch(e) {
      console.error(`ServicioLoginService.getUsuario() : ${e}`);
    }
    return null;
  }

  async getUsuariosBySedesRoles(codigo: string, sedes: string, roles: string) {
    try {
      const request = await this.requestUrl.getFilterRequest(
        'login/by-sedes-roles',
        [ codigo, 
          { 
            'sedes' : sedes,
            'roles' : roles
          }
        ]);
      return request;
    } catch(e) {
      console.error(`ServicioLoginService.getUsuariosBySedesRoles() : ${e}`)
    }
    return null;
  }

  async getInformacionUsuario(code: string, login: number) {
    try{
      const response = await this.requestUrl.getRequest( 'informacion-usuario/datos', [code, { unco_login: login }]);
      return response;
    } catch(e) {
      console.log(`ServicioLogin.getInformacionUsuario() ${e}`);
    }
    return null;
  }

}

export interface LoginEntity {
  unco ?: number;
  usuario ?: string;
  descripcion ?: string;
  nombreUsuario ?: string;
  activaImpresion ?: number;
  telefono ?: string;
  estado ?: boolean;
}